import React, { useCallback } from "react";
import cn from "classnames";

import styles from "./style.module.scss";
import { getFileSizeString } from "../../utils/fileSize";
import { CustomerPaymentReceipt } from "../../types";
import { AttachmentType } from "../../models/attachment";

interface ReceiptAssetItemProps {
  isDisabled?: boolean;
  asset: CustomerPaymentReceipt;
  handleRemoveAsset: (id: string) => void;
}

const ReceiptAssetItem: React.FC<ReceiptAssetItemProps> = (
  props: ReceiptAssetItemProps
) => {
  const { isDisabled, asset, handleRemoveAsset } = props;

  const {
    id,
    type,
    fileUrl,
    fileName,
    fileSize,
    uploadedSize,
    assetId,
  } = asset;

  const isUploaded = assetId !== null;

  const onRemoveAssetClicked = useCallback(() => {
    handleRemoveAsset(id);
  }, [id, handleRemoveAsset]);

  return (
    <div className={styles.assetItem}>
      <div>
        <div
          className={cn(styles.fileIcon, {
            [styles.imageThumbnail]: type === AttachmentType.image,
          })}
          style={{
            backgroundImage:
              type === AttachmentType.image ? `url(${fileUrl})` : undefined,
          }}
        />
        <div className={styles.assetInfo}>
          <div
            className={cn(styles.fileName, {
              [styles.uploaded]: isUploaded,
            })}
          >
            {fileName}
          </div>
          <div className={styles.size}>{getFileSizeString(fileSize)}</div>
        </div>
      </div>
      {!isUploaded && (
        <div className={styles.progress}>
          <div className={styles.progressBar}>
            <div
              className={styles.progressIndicator}
              style={{
                width: `${(uploadedSize / fileSize) * 100}%`,
              }}
            />
          </div>
        </div>
      )}
      <button
        className={styles.closeButton}
        onClick={onRemoveAssetClicked}
        disabled={isDisabled}
      />
    </div>
  );
};

export default ReceiptAssetItem;
